// @flow
import type {ProductPricesWrapper} from "./productPricingTypes";

type PricePack = 'PACK1' | 'PACK2';

type ProductPackRequest = {
  productCode: string,
  packs: PricePack[]
}
type PricesRequest = {
  customerId: ?string,
  postCode: ?string,
  products: ProductPackRequest[]
};

export type PricesResponse = {
  prices: ProductPricesWrapper[]
};

const getProductPrices = async (productCodes: string[], customerId: ?string, postCode: ?string) : Promise<ProductPricesWrapper[]> => {
  const headers = new Headers({
    "Content-Type": `application/json;charset=UTF-8`,
  });

  const requestBody : PricesRequest = {
    customerId,
    postCode,
    products: productCodes.map(productCode => ({
        productCode,
        packs: [`PACK1`, `PACK2`]
      }))
  };

  const data = await fetch(`/trsonline/products/prices/batch`, {
    method: `POST`,
    credentials: "include",
    headers,
    body: JSON.stringify(requestBody)
  });

  const response : PricesResponse = await data.json();

  return response.prices;
};

export default getProductPrices;



// WEBPACK FOOTER //
// ./javascript/product-search-page/product-pricing/getProductPrices.js